// Module
var code = "<div class=\"basket-location-warning\"> <div class=\"basket-location-warning__header\">[[ShippingOutsideOfNorthAmerica]]</div> <div class=\"basket-location-warning__sub-header\">[[CannotShipToCurrentLocation]] (<strong>{{country}}</strong>).</div> <div class=\"basket-location-warning__sub-header\">[[SelectDifferentWebsite]]</div> </div>";
// Exports
module.exports = code;